export enum KYCEnum {
  PENDING = "pending",
  VERIFIED = "verified",
  REJECT = "reject",
}

export enum RegisterDTOEnum {
  PHONE_NUMBER = "phoneNumber",
  EMAIL = "email",
  PASSWORD = "password",
}

export enum KYCStatusEnum {
  DONE = "done",
  DOING = "doing",
  NOT = "not",
  REJECT = "reject",
}

export enum ActiveTransactionEnum {
  ACTIVE = "active",
  DEACTIVE = "deactive",
  UNDEFINED = "undefined",
}

export enum ERegisterType {
  USER = "user",
  BUSINESS = "business",
}

export enum EUserTypes {
  USER = "user",
  BUSINESS = "business",
  SYSTEM = "system",
}

export enum PhoneChangeStep {
  WARNING_BEFORE_CHANGE_PHONE = "Warning before change phone",
  OLD_PHONE_VERIFICATION = "Verify the current phone",
  NEW_PHONE_SUBMISSION = "Submit the new phone",
  NEW_PHONE_CONFIRMATION = "Verify the new phone",
  ADD_NEW_PHONE = "Add new phone",
  VERIFY_ADDING_NEW_PHONE_VERIFICATION = "Verify adding new phone",
  PHONE_REGISTER = "phoneRegister",
}

export enum EmailChangeStep {
  WARNING_BEFORE_CHANGE_EMAIL = "Warning before change email",
  OLD_EMAIL_VERIFICATION = "Verify the current email",
  NEW_EMAIL_SUBMISSION = "Submit the new email",
  NEW_EMAIL_CONFIRMATION = "Verify the new email",
  ADD_NEW_EMAIL = "Add new email",
  VERIFY_ADDING_NEW_EMAIL_VERIFICATION = "Verify adding new email",
  EMAIL_USER_REGISTER = "emailUserRegister",
  EMAIL_BUSINESS_REGISTER = "emailBusinessRegister",
}

export type TKycStatus = KYCEnum;

export type KeyUserRegisterDTO = RegisterDTOEnum;

type ITransactionActivated = {
  chainId: string;
  status: boolean;
};

export class User {
  name: string;
  email: string;
  phoneNumber: string;
  kycStatus: TKycStatus;
  emailVerified: boolean;
  phoneNumberVerified: boolean;
  activeStatus: boolean;
  defaultOtpType: string;
  transactionActivated: ITransactionActivated[];
  hasUploadedKyc: boolean;
  walletAddress: string;
  id: string;
  dateOfBirth?: string;
  idCard?: string;
  passportId?: string;
  address?: string;
  chainId: string;
  avatarUrl?: string;
  accessToken?: string;
  refreshToken?: string;
  userId?: string;
  gender?: string;
  isRetxWallet?: boolean;
  // kycReason?: IMultiLanguages<string>;
  userType: EUserTypes;
  // business
  // companyName?: IMultiLanguages<string>;
  taxCode?: string;
  website?: string;
  // currentAddress?: IOfficeAddress;

  constructor();
  constructor(obj?: User);
  constructor(obj?: any) {
    this.name = obj?.name || "";
    this.email = obj?.email || "";
    this.phoneNumber = obj?.phoneNumber || "";
    this.kycStatus = obj?.kycStatus || "";
    this.emailVerified = obj?.emailVerified || false;
    this.phoneNumberVerified = obj?.phoneNumberVerified || false;
    this.activeStatus = obj?.activeStatus || false;
    this.defaultOtpType = obj?.defaultOtpType || "";
    this.transactionActivated = obj?.transactionActivated || [];
    this.hasUploadedKyc = obj?.hasUploadedKyc || false;
    this.walletAddress = obj?.walletAddress || "";
    this.id = obj?.id || "";
    this.dateOfBirth = obj?.dateOfBirth || "";
    this.idCard = obj?.idCard || "";
    this.passportId = obj?.passportId || "";
    this.address = obj?.address || "";
    this.chainId = obj?.chainId || "";
    this.avatarUrl = obj?.avatarUrl || "";
    this.accessToken = obj?.accessToken || "";
    this.refreshToken = obj?.refreshToken || "";
    this.userId = obj?.userId || "";
    this.gender = obj?.gender || "";
    this.isRetxWallet = obj?.isRetxWallet || false;
    // this.kycReason = obj?.kycReason || { vi: "", en: "" };
    this.userType = obj?.userType || null;
    // this.companyName = obj?.companyName || { vi: "", en: "" };
    this.taxCode = obj?.taxCode || "";
    this.website = obj?.website || "";
    // this.currentAddress = obj?.currentAddress || null;
  }
}

export class UserRegisterDTO {
  phoneNumber: string;
  email: string;
  password: string;
  userId?: string;
  referCode?: string;
  isRetxWallet?: boolean;

  constructor() {
    this.phoneNumber = "";
    this.email = "";
    this.password = "";
    this.userId = "";
    this.referCode = "";
    this.isRetxWallet = true;
  }
}

export class UserUpdateKycDTO {
  fullname: string;
  gender: string;
  faceVideoFile: File;
  frontOfIdCardFile: File;
  backOfIdCardFile: File;
  dateOfBirth: string;
  idCardInfo: string;

  constructor();
  constructor(obj?: UserUpdateKycDTO);
  constructor(obj?: any) {
    this.fullname = obj?.fullname || "";
    this.gender = obj?.gender || "";
    this.faceVideoFile = obj?.faceVideoFile || null;
    this.frontOfIdCardFile = obj?.frontOfIdCardFile || null;
    this.backOfIdCardFile = obj?.backOfIdCardFile || null;
    this.dateOfBirth = obj?.dateOfBirth || null;
    this.idCardInfo = obj?.idCardInfo || "{}";
  }
}

export class InfoOwner {
  id?: string;
  name: string;
  email: string;
  createdAt: Date;
  homeAddress: string;
  phoneNumber: string;
  walletAddress: string;
  address: string;
  avatarUrl: string;
  constructor();
  constructor(obj?: InfoOwner);
  constructor(obj?: any) {
    this.id = obj?.id || "";
    this.name = obj?.name || "";
    this.email = obj?.email || "";
    this.createdAt = new Date(obj?.createdAt || null);
    this.homeAddress = obj?.homeAddress || "";
    this.phoneNumber =
      obj?.phoneNumber != 0 || !obj?.phoneNumber ? obj?.phoneNumber : "";
    this.walletAddress = obj?.walletAddress || "";
    this.address = obj?.address || "";
    this.avatarUrl = obj?.avatarUrl || "";
  }
}
